import { ref } from 'vue'

const PERMISSION_KEY = 'notif_permission_requested'

export function useBrowserNotifications() {
  const permissionState = ref(currentPermission())

  function isSupported() {
    return 'Notification' in window
  }

  function isIOS() {
    return /iphone|ipad|ipod/i.test(navigator.userAgent)
  }

  function isStandalone() {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone
  }

  function isUnsupportedPlatform() {
    return isIOS() && !isStandalone()
  }

  function permission() {
    permissionState.value = currentPermission()
    return permissionState.value
  }

  async function requestPermission() {
    if (!isSupported()) return 'denied'
    if (Notification.permission === 'granted') {
      permissionState.value = 'granted'
      return 'granted'
    }

    localStorage.setItem(PERMISSION_KEY, 'true')
    permissionState.value = await Notification.requestPermission()
    return permissionState.value
  }

  function shouldAutoRequest() {
    return isSupported() && permission() === 'default'
  }

  function show(title, options = {}) {
    if (!isSupported() || permission() !== 'granted') return null

    const notif = new Notification(title, {
      icon: '/logo_small.png',
      badge: '/logo_small.png',
      tag: 'eskrag-notification',
      ...options,
    })

    return notif
  }

  return {
    isSupported,
    isIOS,
    isStandalone,
    isUnsupportedPlatform,
    permissionState,
    permission,
    requestPermission,
    shouldAutoRequest,
    show,
  }
}

function currentPermission() {
  if (!('Notification' in window)) return 'denied'
  return Notification.permission
}
